import React from 'react';
import { HStack } from '~/components/gluestack/hstack';
import { Text } from '~/components/gluestack/text';
import { Pressable } from '~/components/gluestack/pressable';
import { CountryFlagIcon } from '~/components/ui/CountryFlagIcon';
import { useOpenMaps } from '~/hooks/useOpenMaps';
import { useMeasurementFormatters } from '~/components/providers/MeasurementsProvider';

export interface LocationWithFlagRowProps {
  mapsQuery: string;
  countryCode?: string;
  locationText: string;
  distanceKm?: number | null;
  className?: string;
}

export function LocationWithFlagRow({
  mapsQuery,
  countryCode,
  locationText,
  distanceKm,
  className,
}: LocationWithFlagRowProps) {
  const openMaps = useOpenMaps();
  const { formatDistance } = useMeasurementFormatters();

  const hasLocation = !!locationText || !!countryCode;
  if (!hasLocation && distanceKm == null) return null;

  const distanceDisplay =
    distanceKm != null
      ? hasLocation
        ? `(${formatDistance(distanceKm)})`
        : formatDistance(distanceKm)
      : null;

  return (
    <Pressable
      className={className}
      onPress={() => mapsQuery && openMaps(mapsQuery)}
      hitSlop={8}>
      <HStack className="items-center gap-1">
        {countryCode ? (
          <CountryFlagIcon
            countryCode={countryCode}
            size={20}
            className="mr-1 flex-shrink-0"
          />
        ) : null}
        <Text
          size="sm"
          isTruncated
          className="min-w-0 flex-shrink font-medium text-typography-700 web:hover:underline">
          {locationText || ''}
        </Text>
        {distanceDisplay != null ? (
          <Text size="sm" className="flex-shrink-0 font-medium text-typography-700">
            {distanceDisplay}
          </Text>
        ) : null}
      </HStack>
    </Pressable>
  );
}
